module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loading":"Loading...","noOptions":"No choices to choose from"},"fr":{"loading":"Chargement...","noOptions":"Il n\u0027y a pas de choix possible"}}')
  delete Component.options._Ctor
}
